import { render, staticRenderFns } from "./CompanyServices.vue?vue&type=template&id=ca3d2e06&scoped=true"
import script from "./CompanyServices.vue?vue&type=script&lang=js"
export * from "./CompanyServices.vue?vue&type=script&lang=js"
import style0 from "./CompanyServices.vue?vue&type=style&index=0&id=ca3d2e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3d2e06",
  null
  
)

export default component.exports